import { defineMessages } from "react-intl";

export default defineMessages({ 
    managePoliciesTileText: {
        id: "create-account.create-account-landing.Manage policies",
        defaultMessage: "Manage policies"
    },
    payBillsTileText: {
        id: "create-account.create-account-landing.Pay your bill securely",
        defaultMessage: "Pay your bill securely"
    },
    fileAndTrackTileText: {
        id: "create-account.create-account-landing.File and track your claims",
        defaultMessage: "File and track your claims"
    }

});